<template>
  <GlobalSidebarContainer class="hidden-sm-and-down">
    <div class="sidebar-items">
      <FriedSkeleton v-for="n in 5" :key="n" class="sidebar-item" />
    </div>
  </GlobalSidebarContainer>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import GlobalSidebarContainer from './GlobalSidebarContainer.vue';

export default defineComponent({
  components: {
    GlobalSidebarContainer,
  },
});
</script>

<style lang="scss" scoped>
.sidebar-items {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-50);

  .sidebar-item {
    height: 2.5rem;
    width: 100%;
  }
}
</style>
